/* Khuwabb Luxe — shared behaviour for kw- sections and product cards. No dependencies. */
(function () {
  'use strict';
  var animOff = document.body && document.body.getAttribute('data-animations') === 'off';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-kw-reveal]:not(.is-in), .kw-mask:not(.is-in)[data-kw-mask]');
    if (animOff || reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  window.KW = window.KW || {};
  window.KW.reveal = initReveal;

  /* ---------- Card colour swatches: preview image on hover ---------- */
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.kw-sw__dot[data-kw-img]');
    if (!dot) return;
    var card = dot.closest('.pc, .product-card');
    var img = card && card.querySelector('.pc__img:not(.pc__img--b)');
    if (!img) return;
    if (!img.dataset.kwOrig) { img.dataset.kwOrig = img.currentSrc || img.src; img.dataset.kwSet = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset');
    img.src = dot.getAttribute('data-kw-img');
    card.querySelectorAll('.kw-sw__dot').forEach(function (d) { d.classList.toggle('is-on', d === dot); });
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-kw-swatches]');
    if (!sw || sw.contains(e.relatedTarget)) return;
    var card = sw.closest('.pc, .product-card');
    var img = card && card.querySelector('.pc__img:not(.pc__img--b)');
    if (img && img.dataset.kwOrig) { img.src = img.dataset.kwOrig; if (img.dataset.kwSet) img.setAttribute('srcset', img.dataset.kwSet); }
    sw.querySelectorAll('.kw-sw__dot').forEach(function (d) { d.classList.remove('is-on'); });
  });

  /* ---------- Money helper used by sk sections ---------- */
  window.KW.money = function (cents) {
    var fmt = (window.KW.moneyFormat || 'Rs.{{amount_no_decimals}}');
    var n = (cents || 0) / 100;
    var whole = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole).replace(/\{\{\s*amount\s*\}\}/, dec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec.replace('.', ','));
  };

  /* ---------- Add to cart helper (refreshes the theme cart drawer if present) ---------- */
  window.KW.addToCart = function (items) {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (d) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer(true);
      return d;
    });
  };

  function boot() { initReveal(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();

/* Atelier product card: quick add by size + colour swatch preview */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kwk-add]');
    if (!b || b.disabled || !b.getAttribute('data-kwk-add')) return;
    e.preventDefault();
    if (!window.KW || !window.KW.addToCart) return;
    b.disabled = true;
    window.KW.addToCart([{ id: parseInt(b.getAttribute('data-kwk-add'), 10), quantity: 1 }])
      .then(function () { b.classList.add('is-ok'); setTimeout(function () { b.classList.remove('is-ok'); b.disabled = false; }, 1600); })
      .catch(function () { b.disabled = false; });
  });
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.kwk__dot[data-kw-img-src]');
    if (!dot) return;
    var card = dot.closest('.kwk'), img = card && card.querySelector('.kwk__img:not(.kwk__img--b)');
    if (!img) return;
    if (!img.dataset.kwOrig) { img.dataset.kwOrig = img.currentSrc || img.src; img.dataset.kwSet = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset'); img.src = dot.getAttribute('data-kw-img-src');
    card.querySelectorAll('.kwk__dot').forEach(function (d) { d.classList.toggle('is-on', d === dot); });
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.kwk [data-kw-swatches]');
    if (!sw || sw.contains(e.relatedTarget)) return;
    var img = sw.closest('.kwk').querySelector('.kwk__img:not(.kwk__img--b)');
    if (img && img.dataset.kwOrig) { img.src = img.dataset.kwOrig; if (img.dataset.kwSet) img.setAttribute('srcset', img.dataset.kwSet); }
  });
})();
